<div class="block p-2">
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <div sc-placeholder name="ab-login" [rendering]="rendering"></div>
    </div>
    <div class="col-md-12 col-lg-10">
      <form [formGroup]="requestLoginToolForm" (submit)="submitAction()">
        <!-- Select devicetype -->
        <div class="row">
          <div class="form-group col-md-8 mb-0">
            <label *scText="formFields.fields.loginDeviceType.label"></label>
            <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
              <mat-select
                formControlName="mobileDeviceType"
                [placeholder]="formFields.fields.loginDeviceType.defaultValue"
              >
                <mat-option
                  *ngFor="
                    let device of formFields.fields.loginDeviceType.values
                  "
                  [value]="device.fields.Value.value"
                >
                  {{ device.fields.Label.value }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <span
              class="field-validation-error"
              *ngIf="mobileDeviceTypeField.errors?.required"
              >{{ formFields.genericErrors.required.message }}</span
            >
          </div>
        </div>

        <ng-container *ngIf="selectToken">
          <!-- HelpText -->
          <ng-container
            *ngIf="
              mobileDeviceTypeField.value === 'hardToken' ||
              mobileDeviceTypeField.value === 'replaceToken'
            "
          >
            <div class="info-note">
              <i class="icon-exclamation-triangle"></i>
              <span *scText="formFields.fields.helpText.label"></span>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              mobileDeviceTypeField.value !== 'hardToken' &&
              mobileDeviceTypeField.value !== 'replaceToken'
            "
          >
            <div class="info-note">
              <i class="icon-exclamation-triangle"></i>
              <span *scRichText="rendering.fields.sendInfo"></span>
            </div>
            <div class="info-note">
              <i class="icon-exclamation-triangle"></i>
              <span *scRichText="rendering.fields.moreInfo"></span>
            </div>
          </ng-container>

          <!-- Name/Username/DateOfBirth -->
          <div class="row mt-1-5">
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label *scText="formFields.fields.name.label"></label>
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="formFields.fields.name.placeholder"
                  formControlName="name"
                />
                <ng-container *ngIf="formFields.fields.name.helpText">
                  <div
                    class="input-help-text small"
                    *scRichText="formFields.fields.name.helpText"
                  ></div>
                </ng-container>
                <span
                  class="field-validation-error"
                  *ngIf="nameField.errors?.required"
                  >{{ formFields.genericErrors.required.message }}</span
                >
                <span
                  class="field-validation-error"
                  *ngIf="nameField.errors?.pattern"
                  >{{
                    formFields.genericErrors.validationRequestLoginToolNameRegex
                      .message
                  }}</span
                >

                <span
                  class="field-validation-error"
                  *ngIf="nameField.errors?.maxlength"
                  >{{
                    formFields.genericErrors
                      .validationRequestLoginToolNameLength.message
                  }}</span
                >
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group mb-1">
                <label *scText="formFields.fields.username.label"></label>
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="formFields.fields.username.placeholder"
                  formControlName="username"
                />
                <ng-container *ngIf="formFields.fields.username.helpText">
                  <div
                    class="input-help-text small"
                    *scRichText="formFields.fields.username.helpText"
                  ></div>
                </ng-container>
                <span
                  class="field-validation-error"
                  *ngIf="usernameField.errors?.required"
                  >{{ formFields.genericErrors.required.message }}</span
                >
                <span
                  class="field-validation-error"
                  *ngIf="usernameField.errors?.pattern"
                  >{{
                    formFields.genericErrors
                      .validationRequestLoginToolUserNameRegex.message
                  }}</span
                >
                <span
                  class="field-validation-error"
                  *ngIf="usernameField.errors?.maxlength"
                  >{{
                    formFields.genericErrors
                      .validationRequestLoginToolUserNameLength.message
                  }}</span
                >
                <span
                  class="field-validation-error"
                  *ngIf="usernameField.errors?.minlength"
                  >{{
                    formFields.genericErrors
                      .validationRequestLoginToolUserNameRegex.message
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label *scText="formFields.fields.dateOfBirth.label"></label>
                <div
                  class="ab-datepicker"
                  [ngClass]="{
                    'ng-dirty': dateOfBirthField.dirty,
                    'ng-invalid': dateOfBirthField.errors,
                    'ng-touched': dateOfBirthField.touched
                  }"
                >
                  <div class="flex-grow-1">
                    <input
                      class="form-control"
                      abDateFormatter
                      [matDatepicker]="picker1"
                      [min]="minDateOfBirth"
                      [max]="maxDateOfBirth"
                      [placeholder]="formFields.fields.dateOfBirth.placeholder"
                      formControlName="dateOfBirth"
                      maxlength="80"
                      required
                    />
                  </div>
                  <button
                    class="btn btn-default btn-datepicker"
                    (click)="picker1.open()"
                  >
                    <i class="icon-calendar"></i>
                  </button>
                  <mat-datepicker #picker1></mat-datepicker>
                </div>
                <ng-container *ngIf="formFields.fields.dateOfBirth.helpText">
                  <div
                    class="input-help-text small"
                    *scRichText="formFields.fields.dateOfBirth.helpText"
                  ></div>
                </ng-container>
                <span
                  class="field-validation-error"
                  *ngIf="dateOfBirthField.errors?.required"
                  >{{ formFields.genericErrors.required.message }}
                </span>
                <span
                  class="field-validation-error"
                  *ngIf="
                    dateOfBirthField.errors?.matDatepickerMin ||
                    dateOfBirthField.errors?.matDatepickerMax
                  "
                  >{{
                    formFields.genericErrors
                      .validationRequestLoginToolDateOfBirthMaximum.message
                  }}
                </span>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              mobileDeviceTypeField.value === 'hardToken' ||
              mobileDeviceTypeField.value === 'replaceToken'
            "
          >
            <!-- Reason/Branch -->
            <div class="row">
              <div class="form-group col-md-4">
                <label *scText="formFields.fields.pickupBranch.label"></label>
                <mat-form-field
                  class="d-block ab-select"
                  [floatLabel]="'never'"
                >
                  <mat-select
                    formControlName="pickupBranch"
                    [placeholder]="formFields.fields.pickupBranch.defaultValue"
                  >
                    <mat-option
                      *ngFor="
                        let branch of formFields.fields.pickupBranch.values
                      "
                      [value]="branch.fields.Value.value"
                    >
                      {{ branch.fields.Label.value }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <span
                  class="field-validation-error"
                  *ngIf="pickupBranchField.errors?.required"
                  >{{ formFields.genericErrors.required.message }}</span
                >
              </div>
              <div
                class="form-group col-md-4"
                *ngIf="mobileDeviceTypeField.value === 'replaceToken'"
              >
                <label *scText="formFields.fields.reason.label"></label>
                <mat-form-field
                  class="d-block ab-select"
                  [floatLabel]="'never'"
                >
                  <mat-select
                    formControlName="reason"
                    [placeholder]="formFields.fields.reason.defaultValue"
                  >
                    <mat-option
                      *ngFor="let reason of formFields.fields.reason.values"
                      [value]="reason.fields.Value.value"
                    >
                      {{ reason.fields.Label.value }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <span
                  class="field-validation-error"
                  *ngIf="reasonField.errors?.required"
                  >{{ formFields.genericErrors.required.message }}</span
                >
              </div>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
    <!-- Form Bottom Text -->
    <div class="info-box w-100 text-left" *ngIf="selectToken">
      <span *scRichText="formBottomText"></span>
    </div>
    <div class="col-md-10 mt-5">
      <button
        abButtonLoader
        (click)="submitAction()"
        class="btn btn-primary btn-step"
        [disabled]="requestLoginToolForm.invalid"
      >
        <span *scRichText="submitButtonText"></span>
      </button>

      <button
        type="button"
        class="btn btn-link btn-with-icon"
        (click)="cancel()"
      >
        <span *scText="formFields.fields.cancel.label"></span>
      </button>
    </div>
  </div>
</div>
